export default "__VITE_PUBLIC_ASSET__94562bf5__"